import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Screens({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M7.99821 2.99628H16.0015M5.99738 6.74784H18.0024M18.3525 21.0038H5.64723C4.61967 21.0038 3.75916 20.2254 3.6564 19.203L3.00613 12.7003C2.94958 12.1377 3.13375 11.5774 3.51309 11.158C3.89242 10.7387 4.43149 10.4994 4.99696 10.4994H19.0028C19.5683 10.4994 20.1073 10.7387 20.4867 11.158C20.866 11.5774 21.0502 12.1377 20.9936 12.7003L20.3434 19.203C20.2406 20.2254 19.3801 21.0038 18.3525 21.0038Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Screens;